import React, { useMemo, useState, useEffect, useRef } from "react";
import { useUser } from "../../../../../context/UserContext";
import TitlePage from "../../../../../components/general/TitlePage/TitlePage";
import Alert from "../../../../../components/intern/Alert/Alert";
import TablePendingProposals from "../../../../../components/intern/TableInform/TablePendingProposals";
import {
  approveProposal,
  rejectProposal
} from "../../../../../services/proposalsService";
import Input from "../../../../../components/general/Input/Input";
import Select from "../../../../../components/general/Input/Select/Select";

const ProposalsReviewPage = ({ proposals = [] }) => {
  const { authUser } = useUser();
  const emailUser = authUser?.email;
  const containerRef = useRef();

  const authorizedEmails = [
    "marcelo@adsmovil.com", "tamires@adsmovil.com", "ruzito@gmail.com", "raul@adsmovil.com"
  ];
  const isAuthorized = authorizedEmails.includes(emailUser);

  const [alert, setAlert] = useState(null);
  const showAlert = (type, message) => setAlert({ type, message });

  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("dateDesc");


  const proposalsFiltered = useMemo(() => {
    const mine = isAuthorized
      ? proposals
      : proposals.filter((p) => p.submittedBy === emailUser);

    const searchFiltered = mine.filter((p) =>
      p.projectName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.customerName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    let sorted = [...searchFiltered];
    if (sortBy === "dateDesc") {
      sorted.sort((a, b) => new Date(b.sentAt) - new Date(a.sentAt));
    } else if (sortBy === "dateAsc") {
      sorted.sort((a, b) => new Date(a.sentAt) - new Date(b.sentAt));
    } else if (sortBy === "status") {
      const order = ["pending", "approved", "rejected"];
      sorted.sort((a, b) => order.indexOf(a.status) - order.indexOf(b.status));
    }

    return sorted;
  }, [proposals, isAuthorized, emailUser, searchTerm, sortBy]);

  const handleApprove = (row) => {
    approveProposal(row);
    showAlert("adicionar", "Proposal approved!");
  };

  const handleReject = (row) => {
    rejectProposal(row);
    showAlert("info", "Proposal rejected!");
  };

  const handleDownload = (row) => {
    if (row.status !== "approved") {
      return showAlert("erro", "Download available only for approved proposals");
    }
    if (!row.fileUrl) {
      return showAlert("erro", "File not found");
    }
    window.open(row.fileUrl, "_blank");
  };

  // Mapeia o status para exibição com texto + cor + motivo
  const getStatusDisplay = (proposal) => {
    const { status, reason } = proposal;

    switch (status) {
      case "pending":
        return {
          label: "Pending Approval",
          className: "badge badge-pending",
          description: reason || "Waiting for approval"
        };

      case "rejected":
        return {
          label: "Rejected",
          className: "badge badge-rejected",
          description: reason || "Changes required before approval"
        };

      default:
        return {
          label: "Approved",
          className: "badge badge-approved",
          description: null
        };
    }
  };

  return (
    <section className="container-extern content-with-sidebar" ref={containerRef}>
      {alert && (
        <Alert type={alert.type} message={alert.message} onClose={() => setAlert(null)} />
      )}

      <TitlePage
        title="Proposals History & Review"
        subtitle="View, review, approve or reject submitted proposals"
      />

      <div className="search-sort-row">
        <Input
          placeholder="Search proposal..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <Select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          options={[
            { value: "dateDesc", label: "Newest first" },
            { value: "dateAsc", label: "Oldest first" },
            { value: "status", label: "Status" }
          ]}
        />
      </div>

<TablePendingProposals
  data={proposalsFiltered}
  isAuthorized={isAuthorized}
  getStatusDisplay={getStatusDisplay}
  onApprove={handleApprove}
  onReject={handleReject}
  onDownload={handleDownload}
/>


    </section>
  );
};

export default ProposalsReviewPage;
